
import type {
	SketchEntityReferenceDiagnosticKind,
	ExecutionDiagnostic,
} from '../../../../types/reference/sketch-entity-reference/SketchEntityReferenceDiagnostics';

export type {
	SketchEntityReferenceDiagnosticKind,
	ExecutionDiagnostic,
} from '../../../../types/reference/sketch-entity-reference/SketchEntityReferenceDiagnostics';

/**
 * 规范化执行诊断对象。
 * 说明：
 * 1. 当前实现保持零副作用，返回新对象副本；
 * 2. 后续若需要注入时间戳、上下文或序列号，可从这里统一收口。
 *
 * @param diagnostic 原始诊断记录。
 * @returns 复制后的诊断记录。
 */
export function createExecutionDiagnostic(
	diagnostic: ExecutionDiagnostic,
): ExecutionDiagnostic {
	return {
		...diagnostic,
	};
}
